import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query/react'
import { api, nonresidentApi } from 'redux/api'
import { apiErrorMiddleware } from 'redux/middelwares/apiError'
import { FLUSH, PERSIST, persistReducer, persistStore, PURGE, REGISTER } from 'redux-persist'
import sessionStorage from 'redux-persist/es/storage/session'

import applicationSlice from './slices/application-slice'
import authSlice from './slices/auth-slice'
import errorSlice from './slices/error-slice'
import megaCardActivationSlice from './slices/mega-card-activation-slice'
import requestTimeSlice from './slices/requestTimer'
import settingsSlice from './slices/settings-slice'
import stepSlice from './slices/step-slice'

const persistConfig = {
  key: 'root',
  storage: sessionStorage,
  version: 1,
  blacklist: ['api']
}

const rootReducer = combineReducers({
  application: applicationSlice,
  step: stepSlice,
  error: errorSlice,
  auth: authSlice,
  settings: settingsSlice,
  requestTimestamp: requestTimeSlice,
  megaCardActivationSlice: megaCardActivationSlice,
  [api.reducerPath]: api.reducer,
  [nonresidentApi.reducerPath]: nonresidentApi.reducer
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [REGISTER, PERSIST, PURGE, FLUSH, 'requestTimeSlice/setRequestTimestamp'],
        ignoredPaths: ['requestTimestamp.lastRequestTime']
      }
    }).concat(api.middleware, nonresidentApi.middleware, apiErrorMiddleware),
  devTools: import.meta.env.DEV
})

setupListeners(store.dispatch)

export const persistor = persistStore(store)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
